import React from 'react';
import styled from 'styled-components';
import logoImg from '~images/logo-paketti-text.svg';
import { config } from '../configuration';

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 5
        }}
    />
);

const NoInternetConnect = ({ tryAgain, closeApp, techText, switchEnv, switchAuth }) => (
  <Wrapper>
    <Logo>
      <img src={logoImg} alt="logo" />
    </Logo>
    <Text>
      <h3>Virhe</h3>
      <p>Varmista verkkoyhteys ja yritä uudelleen.</p>
      <ColoredLine color="red" />
      <p>Sovellusversio: {config.appVersion}</p>
      <p onClick={switchEnv}>Palvelin: {config.hostname}</p>
      <p onClick={switchAuth}>Tunnistautumistapa: {config.isImprivata ? "Imprivata" : "mPollux"}</p>
      <ColoredLine color="red" />
      <p>Virheilmoitus: {techText}</p>
    </Text>
    <Buttons>
      <Button onClick={tryAgain}>Yritä uudelleen</Button>
      <Close onClick={closeApp}>Sulje sovellus</Close>
    </Buttons>
  </Wrapper>
);

/**
 * STYLED COMPONENTS
 */

const Logo = styled.div`
  text-align: center;
  img {
    width: 100%;
    max-width: 230px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100vh;
  flex-direction: column;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Button = styled.button`
  background: #3d965a;
  border: none;
  border-radius: 3px;
  padding: 10px 12px;
  margin: 0 1px 10px 0;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
`;
const Close = styled.a`
  border: none;
  border-radius: 3px;
  padding: 10px 12px;
  margin: 0 1px 10px 0;
  color: #233c78;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: underline;
`;

const Text = styled.div`
  color: #ff2e51;
  padding: 0 16px;
  font-size: 18px;
  text-align: center;
  p {
    line-height: 1.5;
  }
`;

export default NoInternetConnect;
